$(function() {
    $('a[href^="#"]').click(function() {
        var headerHight = $('header').height();
        var speed = 1000;
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top-headerHight;
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
    });

  if(location.pathname == '/pages/line_friends') {
    location.href = 'https://bit.ly/3OZ0cyY';
  }
});